__turbopack_context__.v({
  "backButton": "AppError-module__03ruzq__backButton",
  "bold": "AppError-module__03ruzq__bold",
  "container": "AppError-module__03ruzq__container",
  "errorIcon": "AppError-module__03ruzq__errorIcon",
  "globalContainer": "AppError-module__03ruzq__globalContainer",
  "orderedList": "AppError-module__03ruzq__orderedList",
  "text": "AppError-module__03ruzq__text",
  "title": "AppError-module__03ruzq__title",
  "tryAgainButton": "AppError-module__03ruzq__tryAgainButton",
  "txNotFoundBar": "AppError-module__03ruzq__txNotFoundBar",
  "txNotFoundBody": "AppError-module__03ruzq__txNotFoundBody",
  "txNotFoundDot": "AppError-module__03ruzq__txNotFoundDot",
  "txNotFoundHeader": "AppError-module__03ruzq__txNotFoundHeader",
  "txNotFoundSnippet": "AppError-module__03ruzq__txNotFoundSnippet",
});
